/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A rapid game is a type of draw game that is drawn very frequently on a time interval, rather than at a fixed set of
 * times. The most common examples of a rapid game are Keno variations.
 * @export
 * @interface RapidGame
 */
export interface RapidGame {
    /**
     * Maximum valid number that can be drawn in this game's primary winning numbers.
     * Used by the hot/cold numbers API to determine the full range of possible values.
     * @type {number}
     * @memberof RapidGame
     * @deprecated
     */
    maxDrawValue?: number | null;
    /**
     * Minimum valid number that can be drawn in this game's primary winning numbers.
     * Used by the hot/cold numbers API to determine the full range of possible values.
     * @type {number}
     * @memberof RapidGame
     * @deprecated
     */
    minDrawValue?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapidGame
     */
    hasProgressiveJackpots: boolean;
    /**
     * How frequently the game has drawings between the draw start and end times
     * @type {number}
     * @memberof RapidGame
     */
    drawFrequencyInMinutes: number;
    /**
     * What minute of the hour drawings for the game end
     * @type {number}
     * @memberof RapidGame
     */
    drawEndMinute: number;
    /**
     * What hour of the day drawings for the game end
     * @type {number}
     * @memberof RapidGame
     */
    drawEndHour: number;
    /**
     * What minute of the hour drawings for the game start
     * @type {number}
     * @memberof RapidGame
     */
    drawStartMinute: number;
    /**
     * What hour of the day drawings for the game start
     * @type {number}
     * @memberof RapidGame
     */
    drawStartHour: number;
    /**
     * Date the game stopped being active. This will be null for a currently active game.
     * @type {Date}
     * @memberof RapidGame
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RapidGame
     */
    activeFrom: Date;
    /**
     * Optional external ID of the game from another system
     * @type {string}
     * @memberof RapidGame
     */
    gameId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapidGame
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RapidGame
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof RapidGame
     */
    id: string;
}

/**
 * Check if a given object implements the RapidGame interface.
 */
export function instanceOfRapidGame(value: object): value is RapidGame {
    if (!('hasProgressiveJackpots' in value) || value['hasProgressiveJackpots'] === undefined) return false;
    if (!('drawFrequencyInMinutes' in value) || value['drawFrequencyInMinutes'] === undefined) return false;
    if (!('drawEndMinute' in value) || value['drawEndMinute'] === undefined) return false;
    if (!('drawEndHour' in value) || value['drawEndHour'] === undefined) return false;
    if (!('drawStartMinute' in value) || value['drawStartMinute'] === undefined) return false;
    if (!('drawStartHour' in value) || value['drawStartHour'] === undefined) return false;
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function RapidGameFromJSON(json: any): RapidGame {
    return RapidGameFromJSONTyped(json, false);
}

export function RapidGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapidGame {
    if (json == null) {
        return json;
    }
    return {
        
        'maxDrawValue': json['maxDrawValue'] == null ? undefined : json['maxDrawValue'],
        'minDrawValue': json['minDrawValue'] == null ? undefined : json['minDrawValue'],
        'hasProgressiveJackpots': json['hasProgressiveJackpots'],
        'drawFrequencyInMinutes': json['drawFrequencyInMinutes'],
        'drawEndMinute': json['drawEndMinute'],
        'drawEndHour': json['drawEndHour'],
        'drawStartMinute': json['drawStartMinute'],
        'drawStartHour': json['drawStartHour'],
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'activeFrom': (new Date(json['activeFrom'])),
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'name': json['name'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function RapidGameToJSON(value?: RapidGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxDrawValue': value['maxDrawValue'],
        'minDrawValue': value['minDrawValue'],
        'hasProgressiveJackpots': value['hasProgressiveJackpots'],
        'drawFrequencyInMinutes': value['drawFrequencyInMinutes'],
        'drawEndMinute': value['drawEndMinute'],
        'drawEndHour': value['drawEndHour'],
        'drawStartMinute': value['drawStartMinute'],
        'drawStartHour': value['drawStartHour'],
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'activeFrom': ((value['activeFrom']).toISOString()),
        'gameId': value['gameId'],
        'name': value['name'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

